import LandingLoader from 'src/assets/images/landing_page.gif';
import ZymedAiLogo from 'src/assets/images/zymed_ai.webp';
import { AppType } from 'src/helpers/rest';

import styles from './index.module.scss';

interface BrandLoadingPropsType {
    app?: AppType;
}

const BrandLoading: React.FunctionComponent<BrandLoadingPropsType> = ({ app }) => {
    return (
        <div className={styles.loader_container}>
            {app === 'zymedelite'
                ? <img src={ZymedAiLogo} alt='gif' />
                : <img src={LandingLoader} alt='gif' className={styles.loader_image} />
            }
        </div>
    );
};

export default BrandLoading;